import { Action } from 'redux'

import { User } from 'src/lib/interfaces/User.interface'
import { Location } from 'src/lib/interfaces/Location.interface'
import { UserAuthority } from 'src/lib/interfaces/UserAuthority.interface'

export const actionTypes = {
  // fetch users
  ADMIN_FETCH_USERS_LIST: 'ADMIN_FETCH_USERS_LIST',
  ADMIN_FETCH_USERS_LIST_FAILED: 'ADMIN_FETCH_USERS_LIST_FAILED',
  ADMIN_FETCH_USERS_LIST_SUCCESS: 'ADMIN_FETCH_USERS_LIST_SUCCESS',

  // fetch all locations
  ADMIN_FETCH_ALL_LOCATIONS_LIST: 'ADMIN_FETCH_ALL_LOCATIONS_LIST',
  ADMIN_FETCH_ALL_LOCATIONS_LIST_FAILED: 'ADMIN_FETCH_ALL_LOCATIONS_LIST_FAILED',
  ADMIN_FETCH_ALL_LOCATIONS_LIST_SUCCESS: 'ADMIN_FETCH_ALL_LOCATIONS_LIST_SUCCESS',

  // fetch all roles
  ADMIN_FETCH_ALL_ROLES_LIST: 'ADMIN_FETCH_ALL_ROLES_LIST',
  ADMIN_FETCH_ALL_ROLES_LIST_FAILED: 'ADMIN_FETCH_ALL_ROLES_LIST_FAILED',
  ADMIN_FETCH_ALL_ROLES_LIST_SUCCESS: 'ADMIN_FETCH_ALL_ROLES_LIST_SUCCESS',

  // toggle user role
  ADMIN_TOGGLE_USER_ROLE: 'ADMIN_TOGGLE_USER_ROLE',
  ADMIN_TOGGLE_USER_ROLE_FAILED: 'ADMIN_TOGGLE_USER_ROLE_FAILED',
  ADMIN_TOGGLE_USER_ROLE_SUCCESS: 'ADMIN_TOGGLE_USER_ROLE_SUCCESS',

  // toggle user location
  ADMIN_TOGGLE_USER_LOCATION: 'ADMIN_TOGGLE_USER_LOCATION',
  ADMIN_TOGGLE_USER_LOCATION_FAILED: 'ADMIN_TOGGLE_USER_LOCATION_FAILED',
  ADMIN_TOGGLE_USER_LOCATION_SUCCESS: 'ADMIN_TOGGLE_USER_LOCATION_SUCCESS'
}

/**
 * Fetch users
 */
export interface AdminFetchUsersListAction extends Action {
  payload: {
    next?: (err?: any, users?: User[]) => void
  }
}

export const fetchUsersList = (next?: (err?: any, users?: User[]) => void): AdminFetchUsersListAction => ({
  type: actionTypes.ADMIN_FETCH_USERS_LIST,
  payload: { next }
})

// Success
export interface AdminFetchUsersListSuccessAction extends Action {
  payload: {
    users: User[]
  }
}

export const fetchUsersListSuccess = (users: User[]): AdminFetchUsersListSuccessAction => ({
  type: actionTypes.ADMIN_FETCH_USERS_LIST_SUCCESS,
  payload: { users }
})

// Error
export interface AdminFetchUsersListErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchUsersListError = (errorMessage?: string): AdminFetchUsersListErrorAction => ({
  type: actionTypes.ADMIN_FETCH_USERS_LIST_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch all locations
 */
export interface AdminFetchAllLocationsListAction extends Action {
  payload: {
    next?: (err?: any, locations?: Location[]) => void
  }
}

export const fetchAllLocationsList = (next?: (err?: any, locations?: Location[]) => void): AdminFetchAllLocationsListAction => ({
  type: actionTypes.ADMIN_FETCH_ALL_LOCATIONS_LIST,
  payload: { next }
})

// Success
export interface AdminFetchAllLocationsListSuccessAction extends Action {
  payload: {
    locations: Location[]
  }
}

export const fetchAllLocationsListSuccess = (locations: Location[]): AdminFetchAllLocationsListSuccessAction => ({
  type: actionTypes.ADMIN_FETCH_ALL_LOCATIONS_LIST_SUCCESS,
  payload: { locations }
})

// Error
export interface AdminFetchAllLocationsListErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchAllLocationsListError = (errorMessage?: string): AdminFetchAllLocationsListErrorAction => ({
  type: actionTypes.ADMIN_FETCH_ALL_LOCATIONS_LIST_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch all roles
 */
export interface AdminFetchAllRolesListAction extends Action {
  payload: {
    next?: (err?: any, roles?: UserAuthority[]) => void
  }
}

export const fetchAllRolesList = (next?: (err?: any, roles?: UserAuthority[]) => void): AdminFetchAllRolesListAction => ({
  type: actionTypes.ADMIN_FETCH_ALL_ROLES_LIST,
  payload: { next }
})

// Success
export interface AdminFetchAllRolesListSuccessAction extends Action {
  payload: {
    roles: UserAuthority[]
  }
}

export const fetchAllRolesListSuccess = (roles: UserAuthority[]): AdminFetchAllRolesListSuccessAction => ({
  type: actionTypes.ADMIN_FETCH_ALL_ROLES_LIST_SUCCESS,
  payload: { roles }
})

// Error
export interface AdminFetchAllRolesListErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchAllRolesListError = (errorMessage?: string): AdminFetchAllRolesListErrorAction => ({
  type: actionTypes.ADMIN_FETCH_ALL_ROLES_LIST_FAILED,
  payload: { errorMessage }
})

/**
 * Toggle user role
 */
export interface AdminToggleUserRoleAction extends Action {
  payload: {
    role: string
    userId: number
    toggle: boolean
    next?: (err?: any, user?: User) => void
  }
}

export const toggleUserRole = (userId: number, role: string, toggle: boolean, next?: (err?: any, user?: User) => void): AdminToggleUserRoleAction => ({
  type: actionTypes.ADMIN_TOGGLE_USER_ROLE,
  payload: { next, role, toggle, userId }
})

// Success
export interface AdminToggleUserRoleSuccessAction extends Action {
  payload: {
    user: User
  }
}

export const toggleUserRoleSuccess = (user: User): AdminToggleUserRoleSuccessAction => ({
  type: actionTypes.ADMIN_TOGGLE_USER_ROLE_SUCCESS,
  payload: { user }
})

// Error
export interface AdminToggleUserRoleErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const toggleUserRoleError = (errorMessage?: string): AdminToggleUserRoleErrorAction => ({
  type: actionTypes.ADMIN_TOGGLE_USER_ROLE_FAILED,
  payload: { errorMessage }
})

/**
 * Toggle user location
 */
export interface AdminToggleUserLocationAction extends Action {
  payload: {
    userId: number
    toggle: boolean
    locationId: number
    next?: (err?: any, user?: User) => void
  }
}

export const toggleUserLocation = (userId: number, locationId: number, toggle: boolean, next?: (err?: any, user?: User) => void): AdminToggleUserLocationAction => ({
  type: actionTypes.ADMIN_TOGGLE_USER_LOCATION,
  payload: { next, toggle, userId, locationId }
})

// Success
export interface AdminToggleUserLocationSuccessAction extends Action {
  payload: {
    user: User
  }
}

export const toggleUserLocationSuccess = (user: User): AdminToggleUserLocationSuccessAction => ({
  type: actionTypes.ADMIN_TOGGLE_USER_LOCATION_SUCCESS,
  payload: { user }
})

// Error
export interface AdminToggleUserLocationErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const toggleUserLocationError = (errorMessage?: string): AdminToggleUserLocationErrorAction => ({
  type: actionTypes.ADMIN_TOGGLE_USER_LOCATION_FAILED,
  payload: { errorMessage }
})

export type AppActionTypes =
  AdminFetchUsersListAction |
  AdminFetchUsersListSuccessAction |
  AdminFetchUsersListErrorAction |
  AdminFetchAllLocationsListAction |
  AdminFetchAllLocationsListSuccessAction |
  AdminFetchAllLocationsListErrorAction |
  AdminFetchAllRolesListAction |
  AdminFetchAllRolesListSuccessAction |
  AdminFetchAllRolesListErrorAction |
  AdminToggleUserRoleAction |
  AdminToggleUserRoleSuccessAction |
  AdminToggleUserRoleErrorAction |
  AdminToggleUserLocationAction |
  AdminToggleUserLocationSuccessAction |
  AdminToggleUserLocationErrorAction



// WEBPACK FOOTER //
// ./src/store/admin/actions.ts